export default __webpack_public_path__ + "f0c34a24874b905b5b7e22ad8fb2c92e.png";